module.exports = __webpack_public_path__ + "static/the-battle-of-vimy-ridge-1b3dadbee6595e00696ad1d6d0ac6db2.jpg";